import { FormFile } from "./formFile";


export class FormInits {
    constructor() {
        this.initMap();
    }

    initMap() {
        new FormFile();
    }
}
